import { render, staticRenderFns } from "./SignatureGenerator.vue?vue&type=template&id=05d373ea&"
import script from "./SignatureGenerator.vue?vue&type=script&lang=js&"
export * from "./SignatureGenerator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports